var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M9 20.1L6.9 18l6-6-6-6L9 3.9l8.1 8.1L9 20.1z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }